/**
 * Mock Subscription Targets Data
 * Sample subscription targets for Andes tables
 * Based on AuroraWeaver configuration patterns
 * @module data/starnexus/mockSubscriptionTargets
 */

import { SubscriptionTarget } from '../../types/starnexus/andesAccess';

/**
 * Sample subscription targets with DATASHARE, CRADLE, and GLUE types
 * IDs follow realistic patterns from AuroraWeaver config
 */
export const mockSubscriptionTargets: SubscriptionTarget[] = [
  // DATASHARE targets
  {
    targetId: 'target-ds-001',
    targetName: 'delta-site-prod-datashare',
    targetType: 'DATASHARE',
    description: 'Production datashare for Delta Site analytics and QuickSight dashboards',
    region: 'us-east-1'
  },
  {
    targetId: 'target-ds-002',
    targetName: 'quicksight-prod-datashare',
    targetType: 'DATASHARE',
    description: 'QuickSight production datashare for business intelligence',
    region: 'us-east-1'
  },
  {
    targetId: 'target-ds-003',
    targetName: 'finance-reporting-datashare',
    targetType: 'DATASHARE',
    description: 'Finance team datashare for financial reporting',
    region: 'us-east-1'
  },
  {
    targetId: 'target-ds-004',
    targetName: 'terra-site-datashare',
    targetType: 'DATASHARE',
    description: 'Terra Site analytics datashare',
    region: 'us-west-2'
  },

  // CRADLE targets
  {
    targetId: 'target-cr-001',
    targetName: 'aurora-weaver-cradle-prod',
    targetType: 'CRADLE',
    description: 'AuroraWeaver production Cradle account for data pipelines',
    region: 'us-east-1'
  },
  {
    targetId: 'target-cr-002',
    targetName: 'aurora-weaver-cradle-dev',
    targetType: 'CRADLE',
    description: 'AuroraWeaver development Cradle account for testing',
    region: 'us-east-1'
  },
  {
    targetId: 'target-cr-003',
    targetName: 'agl-etl-cradle-prod',
    targetType: 'CRADLE',
    description: 'AGL ETL production Cradle for data transformation',
    region: 'us-east-1'
  },
  {
    targetId: 'target-cr-004',
    targetName: 'bizops-cradle-prod',
    targetType: 'CRADLE',
    description: 'Business Operations Cradle for operational analytics',
    region: 'us-west-2'
  },

  // GLUE targets
  {
    targetId: 'target-gl-001',
    targetName: 'agl-analytics-glue-catalog',
    targetType: 'GLUE',
    description: 'AGL Analytics Glue Data Catalog for cross-region queries',
    region: 'us-west-2'
  },
  {
    targetId: 'target-gl-002',
    targetName: 'inventory-glue-catalog',
    targetType: 'GLUE',
    description: 'Inventory management Glue catalog',
    region: 'eu-west-1'
  },
  {
    targetId: 'target-gl-003',
    targetName: 'ml-training-glue-catalog',
    targetType: 'GLUE',
    description: 'Machine Learning training data Glue catalog',
    region: 'us-east-1'
  },
  {
    targetId: 'target-gl-004',
    targetName: 'apac-analytics-glue-catalog',
    targetType: 'GLUE',
    description: 'APAC region analytics Glue catalog',
    region: 'ap-northeast-1'
  }
];

export default mockSubscriptionTargets;
